import React from "react";
import "./style.css";

const AssociatedAssetsCmp = () => {
  return <div className='associated_assets'>M</div>;
};
export default AssociatedAssetsCmp;
